import { configureStore, createSlice } from '@reduxjs/toolkit';

import leadReducer from './leadData/leadSlice';
import plaidTriggerReducer from './leadData/plaidSlice';

interface AppState {
  loading: boolean;
}

const appInitialState: AppState = {
  loading: false,
};

const AppSlice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: {
    setAppLoading(state, action) {
      console.log({state, action})
      state.loading = action.payload;
    },
  },
});

export const { setAppLoading } = AppSlice.actions;

const store = configureStore({
  reducer: {
    lead: leadReducer,
    plaidTrigger: plaidTriggerReducer,
    app: AppSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
